import { CheckCircleIcon, Typography } from "@cpj-ai/panel-npm-package";
import {
  AuthAccountJobPositionAssignmentStatusHistoryStatusChoices,
  JobPositionAssignmentStatusHistoryType,
} from "@graphql/generated";
import { BASE_CONFIG } from "./constants";
import { StatusConfigResult } from "./types";

export const getStatusConfig = (
  history: JobPositionAssignmentStatusHistoryType,
  isLastStatus: boolean,
): StatusConfigResult => {
  const defaultConfig = {
    title: "Status Update",
    icon: <CheckCircleIcon className="w-6 h-6" stroke="#3F3F46" />,
  };
  const status = history.status;

  const config = BASE_CONFIG[status as AuthAccountJobPositionAssignmentStatusHistoryStatusChoices] || defaultConfig;

  return {
    title: config.title,
    status: isLastStatus ? config.status : "default",
    icon: isLastStatus ? config.icon : defaultConfig.icon,
    content: (
      <>
        <div className="flex flex-col gap-2">
          <Typography>{config.content}</Typography>
          {isLastStatus && config.action}
        </div>
      </>
    ),
  };
};
